var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ProductRating flex items-center space-x-1"},[_c('svg-icon',{staticClass:"w-4 h-4",class:{
      'is-active': _vm.rating,
    },attrs:{"name":_vm.rating ? 'star' : 'star-dimmed'}}),_vm._v(" "),(_vm.rating)?_c('span',{staticClass:"text-primary-800"},[_vm._v("\n    "+_vm._s(_vm.$t('rating', { rating: _vm.rating }))+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }